/**
 * A pull promise is a promise that is returned when pulling a dataframe from a graph.
 */
export class PullPromise extends Promise {}